import type { EntityType } from "@app-types/entity-type";

/**
 * pathから性別とその性別の反対の性別を返す関数
 *
 * @returns {object} genderにメイン、targetGenderに相手の性別、
 *                    genderBasePathに性別/相手の性別の積み上げパスが入る
 */
export const getGender = (): {
  gender: EntityType;
  targetGender: EntityType;
  genderBasePath: string;
} => {
  const pathGender = location.pathname.split("/")[1];
  const gender: EntityType = pathGender === "lady" ? "lady" : "user";
  const targetGender: EntityType = gender === "user" ? "lady" : "user";
  const genderBasePath = `/${gender}/${targetGender}`;
  return { gender, targetGender, genderBasePath };
};
